var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('MarketplaceProductsShopSection',{attrs:{"shopId":_vm.shopId,"shopInfo":_vm.shopInfo}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }